module.exports = __webpack_public_path__ + "img/smith-major-6LqvNoUjySI-unsplash.64a0adc2.jpg";